<template>
    <div class="wk-rang-fixed-time">
        <el-time-select
            placeholder="起始时间"
            v-model="startTime"
            :picker-options="pickerOptions">
        </el-time-select>
        <span style="padding: 0 6px;">至</span>
        <el-time-select
            placeholder="结束时间"
            v-model="endTime"
            :picker-options="{
            ...pickerOptions,
            minTime: startTime
            }">
        </el-time-select>
    </div>
</template>
<script>
import _ from 'lodash'
export default {
    name: 'WkRangFixedTime',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        pickerOptions: {
            type: Object,
            default: () => ({
                start: '00:00',
                step: '00:30',
                end: '24:00'
            })
        }
    },
    watch: {
        value: {
            handler(newVal, oldValue) {
                if (_.isEqual(newVal, oldValue)) {
                    return;
                };
                if(!_.isNull(newVal) && newVal.length > 0) {
                    console.log('newVal', newVal)
                    this.startTime = newVal[0] || '';
                    this.endTime = newVal[1] || '';
                }
            },
            deep: true,
            immediate: true
        },
        startTime: {
            handler(newVal, oldValue) {
                if (_.isEqual(newVal, oldValue)) {
                    return;
                };
                this.$emit('input', [newVal, this.endTime]);
            }
        },
        endTime: {
            handler(newVal, oldValue) {
                if (_.isEqual(newVal, oldValue)) {
                    return;
                };
                this.$emit('input', [this.startTime, newVal]);
            }
        }
    },
    data() {
        return {
            startTime: '',
            endTime: ''
        }
    },
    methods: {
    }
}
</script>